/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AlertState {
  toggleAlert: boolean;
  type: 'success' | 'error';
  message: string;
}

const initialState: AlertState = {
  toggleAlert: false,
  type: 'success',
  message: '',
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    setAlert: (
      state: AlertState,
      { payload }: PayloadAction<Omit<AlertState, 'toggleAlert'>>,
    ) => {
      state.type = payload.type;
      state.message = payload.message;
      state.toggleAlert = true;
    },
    closeAlert: (state: AlertState) => {
      state.message = '';
      state.toggleAlert = false;
    },
  },
});

export const { setAlert, closeAlert } = alertSlice.actions;

export default alertSlice.reducer;
